<template>
  <web-view :src="url"></web-view>
</template>

<script>
import { ASSETS } from './assets.js';

export default {
  data() {
    return {
      url: ASSETS.vr_url
    }
  }
}
</script>
